export default "__VITE_ASSET__5b12a3fc__"